// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { Card } from '../../../lib/base';
import { PageLoading } from '../loading';
import PageViewHeader from './PageViewHeader';
import TableView, { type ColumnsType } from './TableView';

interface Props {
  id?: string;
  title: string;
  name: string;
  pluralName: string;
  pluralRoute: string;
  groupName?: string;
  groupRoute?: string;
  searchRoute: string;
  noBreadcrumb?: boolean;
  headerIcon?: string;
  loading?: boolean;
  headerBackgroundColorClassName?: string;
  headerRightElement?: React.ReactElement;
  bodyColumns: ColumnsType;
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  extraCard?: any;
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  extra?: any;
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  children?: any;
}
function PageView({
  id,
  title,
  name,
  pluralName,
  pluralRoute,
  groupName,
  groupRoute,
  searchRoute,
  noBreadcrumb,
  headerIcon,
  loading,
  headerBackgroundColorClassName,
  headerRightElement,
  bodyColumns,
  extraCard,
  extra,
}: Props): React.ReactElement {
  return (
    <>
      <Card>
        <PageViewHeader
          id={id}
          title={title}
          name={name}
          pluralName={pluralName}
          pluralRoute={pluralRoute}
          groupName={groupName}
          groupRoute={groupRoute}
          searchRoute={searchRoute}
          icon={headerIcon}
          backgroundColorClassName={headerBackgroundColorClassName}
          rightElement={headerRightElement}
          noBreadcrumb={noBreadcrumb}
        />
        {loading ? <PageLoading /> : <TableView columns={bodyColumns} />}
        {loading ? null : extraCard}
      </Card>
      {loading ? null : extra}
    </>
  );
}

export default PageView;
